import { render, staticRenderFns } from "./BusManage.vue?vue&type=template&id=058e62a6&scoped=true&"
import script from "./BusManage.vue?vue&type=script&lang=js&"
export * from "./BusManage.vue?vue&type=script&lang=js&"
import style0 from "./BusManage.vue?vue&type=style&index=0&id=058e62a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e62a6",
  null
  
)

export default component.exports